// components/BlogSectionRelatedPosts.js
import { BlogPost } from './BlogPost'

const BlogSectionRelatedPosts = ({
    initialPosts,
    initialCategories,
    viewStyle = 'horizontal',
}) => {
    return (
        <div className="container mx-auto px-4">
            {initialPosts.length > 0 && (
                <div className="space-y-6">
                    {initialPosts.map((post) => (
                        <BlogPost
                            key={post.id}
                            post={post}
                            categories={initialCategories}
                            className="blog-post"
                            showExcerpt={false}
                            isSidePosts={true}
                            image="small"
                            viewStyle={viewStyle} // Add this prop to handle the view style
                        />
                    ))}
                </div>
            )}
        </div>
    )
}

export default BlogSectionRelatedPosts
